/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as TasksRouteImport } from './routes/tasks'
import { Route as SurveysRouteImport } from './routes/surveys'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SchedulingRouteImport } from './routes/scheduling'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ReadLaterRouteImport } from './routes/read-later'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as ParentRouteImport } from './routes/parent'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as MembersRouteImport } from './routes/members'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as GuideRouteImport } from './routes/guide'
import { Route as ForumRouteImport } from './routes/forum'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as BookmarksRouteImport } from './routes/bookmarks'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GuideIndexRouteImport } from './routes/guide.index'
import { Route as GroupsIndexRouteImport } from './routes/groups.index'
import { Route as ArticlesIndexRouteImport } from './routes/articles.index'
import { Route as UsersUserIdRouteImport } from './routes/users.$userId'
import { Route as TagsSlugRouteImport } from './routes/tags.$slug'
import { Route as SurveysNewRouteImport } from './routes/surveys_.new'
import { Route as SurveysSurveyIdRouteImport } from './routes/surveys_.$surveyId'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as LibraryDownloadsRouteImport } from './routes/library_.downloads'
import { Route as LibraryFolderIdRouteImport } from './routes/library_.$folderId'
import { Route as InvitesTokenRouteImport } from './routes/invites.$token'
import { Route as GuideTopicRouteImport } from './routes/guide.$topic'
import { Route as GroupsSlugRouteImport } from './routes/groups.$slug'
import { Route as ForumNewRouteImport } from './routes/forum_.new'
import { Route as ForumThreadIdRouteImport } from './routes/forum_.$threadId'
import { Route as DeskNewsletterRouteImport } from './routes/desk.newsletter'
import { Route as CategoriesSlugRouteImport } from './routes/categories.$slug'
import { Route as CalendarSchedulingRouteImport } from './routes/calendar_.scheduling'
import { Route as CalendarCoordinationRouteImport } from './routes/calendar_.coordination'
import { Route as ArticlesNewRouteImport } from './routes/articles.new'
import { Route as ArticlesSlugRouteImport } from './routes/articles.$slug'
import { Route as SurveysSurveyIdIndexRouteImport } from './routes/surveys_.$surveyId.index'
import { Route as ArticlesSlugIndexRouteImport } from './routes/articles.$slug.index'
import { Route as SurveysSurveyIdRespondRouteImport } from './routes/surveys_.$surveyId.respond'
import { Route as SurveysSurveyIdEditRouteImport } from './routes/surveys_.$surveyId.edit'
import { Route as InvitesDirectInviteIdRouteImport } from './routes/invites.direct.$inviteId'
import { Route as ForumPostPostIdRouteImport } from './routes/forum_.post.$postId'
import { Route as CalendarEventsEventIdRouteImport } from './routes/calendar_.events.$eventId'
import { Route as ArticlesSlugEditRouteImport } from './routes/articles.$slug.edit'
import { Route as UsersUserIdCollectionsSlugRouteImport } from './routes/users.$userId.collections.$slug'
import { Route as LibraryFoldersFolderIdShareRouteImport } from './routes/library_.folders.$folderId.share'
import { Route as LibraryFilesFileIdShareRouteImport } from './routes/library_.files.$fileId.share'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksRoute = TasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const SurveysRoute = SurveysRouteImport.update({
  id: '/surveys',
  path: '/surveys',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulingRoute = SchedulingRouteImport.update({
  id: '/scheduling',
  path: '/scheduling',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ReadLaterRoute = ReadLaterRouteImport.update({
  id: '/read-later',
  path: '/read-later',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentRoute = ParentRouteImport.update({
  id: '/parent',
  path: '/parent',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const MembersRoute = MembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryRoute = LibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => rootRouteImport,
} as any)
const GuideRoute = GuideRouteImport.update({
  id: '/guide',
  path: '/guide',
  getParentRoute: () => rootRouteImport,
} as any)
const ForumRoute = ForumRouteImport.update({
  id: '/forum',
  path: '/forum',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const BookmarksRoute = BookmarksRouteImport.update({
  id: '/bookmarks',
  path: '/bookmarks',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const GuideIndexRoute = GuideIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GuideRoute,
} as any)
const GroupsIndexRoute = GroupsIndexRouteImport.update({
  id: '/groups/',
  path: '/groups/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesIndexRoute = ArticlesIndexRouteImport.update({
  id: '/articles/',
  path: '/articles/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersUserIdRoute = UsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const TagsSlugRoute = TagsSlugRouteImport.update({
  id: '/tags/$slug',
  path: '/tags/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const SurveysNewRoute = SurveysNewRouteImport.update({
  id: '/surveys_/new',
  path: '/surveys/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SurveysSurveyIdRoute = SurveysSurveyIdRouteImport.update({
  id: '/surveys_/$surveyId',
  path: '/surveys/$surveyId',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryDownloadsRoute = LibraryDownloadsRouteImport.update({
  id: '/library_/downloads',
  path: '/library/downloads',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryFolderIdRoute = LibraryFolderIdRouteImport.update({
  id: '/library_/$folderId',
  path: '/library/$folderId',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitesTokenRoute = InvitesTokenRouteImport.update({
  id: '/invites/$token',
  path: '/invites/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const GuideTopicRoute = GuideTopicRouteImport.update({
  id: '/$topic',
  path: '/$topic',
  getParentRoute: () => GuideRoute,
} as any)
const GroupsSlugRoute = GroupsSlugRouteImport.update({
  id: '/groups/$slug',
  path: '/groups/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ForumNewRoute = ForumNewRouteImport.update({
  id: '/forum_/new',
  path: '/forum/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ForumThreadIdRoute = ForumThreadIdRouteImport.update({
  id: '/forum_/$threadId',
  path: '/forum/$threadId',
  getParentRoute: () => rootRouteImport,
} as any)
const DeskNewsletterRoute = DeskNewsletterRouteImport.update({
  id: '/desk/newsletter',
  path: '/desk/newsletter',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesSlugRoute = CategoriesSlugRouteImport.update({
  id: '/categories/$slug',
  path: '/categories/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarSchedulingRoute = CalendarSchedulingRouteImport.update({
  id: '/calendar_/scheduling',
  path: '/calendar/scheduling',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarCoordinationRoute = CalendarCoordinationRouteImport.update({
  id: '/calendar_/coordination',
  path: '/calendar/coordination',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesNewRoute = ArticlesNewRouteImport.update({
  id: '/articles/new',
  path: '/articles/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesSlugRoute = ArticlesSlugRouteImport.update({
  id: '/articles/$slug',
  path: '/articles/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const SurveysSurveyIdIndexRoute = SurveysSurveyIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SurveysSurveyIdRoute,
} as any)
const ArticlesSlugIndexRoute = ArticlesSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ArticlesSlugRoute,
} as any)
const SurveysSurveyIdRespondRoute = SurveysSurveyIdRespondRouteImport.update({
  id: '/respond',
  path: '/respond',
  getParentRoute: () => SurveysSurveyIdRoute,
} as any)
const SurveysSurveyIdEditRoute = SurveysSurveyIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => SurveysSurveyIdRoute,
} as any)
const InvitesDirectInviteIdRoute = InvitesDirectInviteIdRouteImport.update({
  id: '/invites/direct/$inviteId',
  path: '/invites/direct/$inviteId',
  getParentRoute: () => rootRouteImport,
} as any)
const ForumPostPostIdRoute = ForumPostPostIdRouteImport.update({
  id: '/forum_/post/$postId',
  path: '/forum/post/$postId',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarEventsEventIdRoute = CalendarEventsEventIdRouteImport.update({
  id: '/calendar_/events/$eventId',
  path: '/calendar/events/$eventId',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesSlugEditRoute = ArticlesSlugEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => ArticlesSlugRoute,
} as any)
const UsersUserIdCollectionsSlugRoute =
  UsersUserIdCollectionsSlugRouteImport.update({
    id: '/collections/$slug',
    path: '/collections/$slug',
    getParentRoute: () => UsersUserIdRoute,
  } as any)
const LibraryFoldersFolderIdShareRoute =
  LibraryFoldersFolderIdShareRouteImport.update({
    id: '/library_/folders/$folderId/share',
    path: '/library/folders/$folderId/share',
    getParentRoute: () => rootRouteImport,
  } as any)
const LibraryFilesFileIdShareRoute = LibraryFilesFileIdShareRouteImport.update({
  id: '/library_/files/$fileId/share',
  path: '/library/files/$fileId/share',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/bookmarks': typeof BookmarksRoute
  '/calendar': typeof CalendarRoute
  '/dashboard': typeof DashboardRoute
  '/forum': typeof ForumRoute
  '/guide': typeof GuideRouteWithChildren
  '/library': typeof LibraryRoute
  '/login': typeof LoginRoute
  '/members': typeof MembersRoute
  '/notifications': typeof NotificationsRoute
  '/parent': typeof ParentRoute
  '/profile': typeof ProfileRoute
  '/read-later': typeof ReadLaterRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/scheduling': typeof SchedulingRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/surveys': typeof SurveysRoute
  '/tasks': typeof TasksRoute
  '/verify-email': typeof VerifyEmailRoute
  '/articles/$slug': typeof ArticlesSlugRouteWithChildren
  '/articles/new': typeof ArticlesNewRoute
  '/calendar/coordination': typeof CalendarCoordinationRoute
  '/calendar/scheduling': typeof CalendarSchedulingRoute
  '/categories/$slug': typeof CategoriesSlugRoute
  '/desk/newsletter': typeof DeskNewsletterRoute
  '/forum/$threadId': typeof ForumThreadIdRoute
  '/forum/new': typeof ForumNewRoute
  '/groups/$slug': typeof GroupsSlugRoute
  '/guide/$topic': typeof GuideTopicRoute
  '/invites/$token': typeof InvitesTokenRoute
  '/library/$folderId': typeof LibraryFolderIdRoute
  '/library/downloads': typeof LibraryDownloadsRoute
  '/s/$token': typeof STokenRoute
  '/surveys/$surveyId': typeof SurveysSurveyIdRouteWithChildren
  '/surveys/new': typeof SurveysNewRoute
  '/tags/$slug': typeof TagsSlugRoute
  '/users/$userId': typeof UsersUserIdRouteWithChildren
  '/articles/': typeof ArticlesIndexRoute
  '/groups/': typeof GroupsIndexRoute
  '/guide/': typeof GuideIndexRoute
  '/articles/$slug/edit': typeof ArticlesSlugEditRoute
  '/calendar/events/$eventId': typeof CalendarEventsEventIdRoute
  '/forum/post/$postId': typeof ForumPostPostIdRoute
  '/invites/direct/$inviteId': typeof InvitesDirectInviteIdRoute
  '/surveys/$surveyId/edit': typeof SurveysSurveyIdEditRoute
  '/surveys/$surveyId/respond': typeof SurveysSurveyIdRespondRoute
  '/articles/$slug/': typeof ArticlesSlugIndexRoute
  '/surveys/$surveyId/': typeof SurveysSurveyIdIndexRoute
  '/library/files/$fileId/share': typeof LibraryFilesFileIdShareRoute
  '/library/folders/$folderId/share': typeof LibraryFoldersFolderIdShareRoute
  '/users/$userId/collections/$slug': typeof UsersUserIdCollectionsSlugRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/bookmarks': typeof BookmarksRoute
  '/calendar': typeof CalendarRoute
  '/dashboard': typeof DashboardRoute
  '/forum': typeof ForumRoute
  '/library': typeof LibraryRoute
  '/login': typeof LoginRoute
  '/members': typeof MembersRoute
  '/notifications': typeof NotificationsRoute
  '/parent': typeof ParentRoute
  '/profile': typeof ProfileRoute
  '/read-later': typeof ReadLaterRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/scheduling': typeof SchedulingRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/surveys': typeof SurveysRoute
  '/tasks': typeof TasksRoute
  '/verify-email': typeof VerifyEmailRoute
  '/articles/new': typeof ArticlesNewRoute
  '/calendar/coordination': typeof CalendarCoordinationRoute
  '/calendar/scheduling': typeof CalendarSchedulingRoute
  '/categories/$slug': typeof CategoriesSlugRoute
  '/desk/newsletter': typeof DeskNewsletterRoute
  '/forum/$threadId': typeof ForumThreadIdRoute
  '/forum/new': typeof ForumNewRoute
  '/groups/$slug': typeof GroupsSlugRoute
  '/guide/$topic': typeof GuideTopicRoute
  '/invites/$token': typeof InvitesTokenRoute
  '/library/$folderId': typeof LibraryFolderIdRoute
  '/library/downloads': typeof LibraryDownloadsRoute
  '/s/$token': typeof STokenRoute
  '/surveys/new': typeof SurveysNewRoute
  '/tags/$slug': typeof TagsSlugRoute
  '/users/$userId': typeof UsersUserIdRouteWithChildren
  '/articles': typeof ArticlesIndexRoute
  '/groups': typeof GroupsIndexRoute
  '/guide': typeof GuideIndexRoute
  '/articles/$slug/edit': typeof ArticlesSlugEditRoute
  '/calendar/events/$eventId': typeof CalendarEventsEventIdRoute
  '/forum/post/$postId': typeof ForumPostPostIdRoute
  '/invites/direct/$inviteId': typeof InvitesDirectInviteIdRoute
  '/surveys/$surveyId/edit': typeof SurveysSurveyIdEditRoute
  '/surveys/$surveyId/respond': typeof SurveysSurveyIdRespondRoute
  '/articles/$slug': typeof ArticlesSlugIndexRoute
  '/surveys/$surveyId': typeof SurveysSurveyIdIndexRoute
  '/library/files/$fileId/share': typeof LibraryFilesFileIdShareRoute
  '/library/folders/$folderId/share': typeof LibraryFoldersFolderIdShareRoute
  '/users/$userId/collections/$slug': typeof UsersUserIdCollectionsSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/bookmarks': typeof BookmarksRoute
  '/calendar': typeof CalendarRoute
  '/dashboard': typeof DashboardRoute
  '/forum': typeof ForumRoute
  '/guide': typeof GuideRouteWithChildren
  '/library': typeof LibraryRoute
  '/login': typeof LoginRoute
  '/members': typeof MembersRoute
  '/notifications': typeof NotificationsRoute
  '/parent': typeof ParentRoute
  '/profile': typeof ProfileRoute
  '/read-later': typeof ReadLaterRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/scheduling': typeof SchedulingRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/surveys': typeof SurveysRoute
  '/tasks': typeof TasksRoute
  '/verify-email': typeof VerifyEmailRoute
  '/articles/$slug': typeof ArticlesSlugRouteWithChildren
  '/articles/new': typeof ArticlesNewRoute
  '/calendar_/coordination': typeof CalendarCoordinationRoute
  '/calendar_/scheduling': typeof CalendarSchedulingRoute
  '/categories/$slug': typeof CategoriesSlugRoute
  '/desk/newsletter': typeof DeskNewsletterRoute
  '/forum_/$threadId': typeof ForumThreadIdRoute
  '/forum_/new': typeof ForumNewRoute
  '/groups/$slug': typeof GroupsSlugRoute
  '/guide/$topic': typeof GuideTopicRoute
  '/invites/$token': typeof InvitesTokenRoute
  '/library_/$folderId': typeof LibraryFolderIdRoute
  '/library_/downloads': typeof LibraryDownloadsRoute
  '/s/$token': typeof STokenRoute
  '/surveys_/$surveyId': typeof SurveysSurveyIdRouteWithChildren
  '/surveys_/new': typeof SurveysNewRoute
  '/tags/$slug': typeof TagsSlugRoute
  '/users/$userId': typeof UsersUserIdRouteWithChildren
  '/articles/': typeof ArticlesIndexRoute
  '/groups/': typeof GroupsIndexRoute
  '/guide/': typeof GuideIndexRoute
  '/articles/$slug/edit': typeof ArticlesSlugEditRoute
  '/calendar_/events/$eventId': typeof CalendarEventsEventIdRoute
  '/forum_/post/$postId': typeof ForumPostPostIdRoute
  '/invites/direct/$inviteId': typeof InvitesDirectInviteIdRoute
  '/surveys_/$surveyId/edit': typeof SurveysSurveyIdEditRoute
  '/surveys_/$surveyId/respond': typeof SurveysSurveyIdRespondRoute
  '/articles/$slug/': typeof ArticlesSlugIndexRoute
  '/surveys_/$surveyId/': typeof SurveysSurveyIdIndexRoute
  '/library_/files/$fileId/share': typeof LibraryFilesFileIdShareRoute
  '/library_/folders/$folderId/share': typeof LibraryFoldersFolderIdShareRoute
  '/users/$userId/collections/$slug': typeof UsersUserIdCollectionsSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/bookmarks'
    | '/calendar'
    | '/dashboard'
    | '/forum'
    | '/guide'
    | '/library'
    | '/login'
    | '/members'
    | '/notifications'
    | '/parent'
    | '/profile'
    | '/read-later'
    | '/register'
    | '/reset-password'
    | '/scheduling'
    | '/search'
    | '/settings'
    | '/surveys'
    | '/tasks'
    | '/verify-email'
    | '/articles/$slug'
    | '/articles/new'
    | '/calendar/coordination'
    | '/calendar/scheduling'
    | '/categories/$slug'
    | '/desk/newsletter'
    | '/forum/$threadId'
    | '/forum/new'
    | '/groups/$slug'
    | '/guide/$topic'
    | '/invites/$token'
    | '/library/$folderId'
    | '/library/downloads'
    | '/s/$token'
    | '/surveys/$surveyId'
    | '/surveys/new'
    | '/tags/$slug'
    | '/users/$userId'
    | '/articles/'
    | '/groups/'
    | '/guide/'
    | '/articles/$slug/edit'
    | '/calendar/events/$eventId'
    | '/forum/post/$postId'
    | '/invites/direct/$inviteId'
    | '/surveys/$surveyId/edit'
    | '/surveys/$surveyId/respond'
    | '/articles/$slug/'
    | '/surveys/$surveyId/'
    | '/library/files/$fileId/share'
    | '/library/folders/$folderId/share'
    | '/users/$userId/collections/$slug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/bookmarks'
    | '/calendar'
    | '/dashboard'
    | '/forum'
    | '/library'
    | '/login'
    | '/members'
    | '/notifications'
    | '/parent'
    | '/profile'
    | '/read-later'
    | '/register'
    | '/reset-password'
    | '/scheduling'
    | '/search'
    | '/settings'
    | '/surveys'
    | '/tasks'
    | '/verify-email'
    | '/articles/new'
    | '/calendar/coordination'
    | '/calendar/scheduling'
    | '/categories/$slug'
    | '/desk/newsletter'
    | '/forum/$threadId'
    | '/forum/new'
    | '/groups/$slug'
    | '/guide/$topic'
    | '/invites/$token'
    | '/library/$folderId'
    | '/library/downloads'
    | '/s/$token'
    | '/surveys/new'
    | '/tags/$slug'
    | '/users/$userId'
    | '/articles'
    | '/groups'
    | '/guide'
    | '/articles/$slug/edit'
    | '/calendar/events/$eventId'
    | '/forum/post/$postId'
    | '/invites/direct/$inviteId'
    | '/surveys/$surveyId/edit'
    | '/surveys/$surveyId/respond'
    | '/articles/$slug'
    | '/surveys/$surveyId'
    | '/library/files/$fileId/share'
    | '/library/folders/$folderId/share'
    | '/users/$userId/collections/$slug'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/bookmarks'
    | '/calendar'
    | '/dashboard'
    | '/forum'
    | '/guide'
    | '/library'
    | '/login'
    | '/members'
    | '/notifications'
    | '/parent'
    | '/profile'
    | '/read-later'
    | '/register'
    | '/reset-password'
    | '/scheduling'
    | '/search'
    | '/settings'
    | '/surveys'
    | '/tasks'
    | '/verify-email'
    | '/articles/$slug'
    | '/articles/new'
    | '/calendar_/coordination'
    | '/calendar_/scheduling'
    | '/categories/$slug'
    | '/desk/newsletter'
    | '/forum_/$threadId'
    | '/forum_/new'
    | '/groups/$slug'
    | '/guide/$topic'
    | '/invites/$token'
    | '/library_/$folderId'
    | '/library_/downloads'
    | '/s/$token'
    | '/surveys_/$surveyId'
    | '/surveys_/new'
    | '/tags/$slug'
    | '/users/$userId'
    | '/articles/'
    | '/groups/'
    | '/guide/'
    | '/articles/$slug/edit'
    | '/calendar_/events/$eventId'
    | '/forum_/post/$postId'
    | '/invites/direct/$inviteId'
    | '/surveys_/$surveyId/edit'
    | '/surveys_/$surveyId/respond'
    | '/articles/$slug/'
    | '/surveys_/$surveyId/'
    | '/library_/files/$fileId/share'
    | '/library_/folders/$folderId/share'
    | '/users/$userId/collections/$slug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  BookmarksRoute: typeof BookmarksRoute
  CalendarRoute: typeof CalendarRoute
  DashboardRoute: typeof DashboardRoute
  ForumRoute: typeof ForumRoute
  GuideRoute: typeof GuideRouteWithChildren
  LibraryRoute: typeof LibraryRoute
  LoginRoute: typeof LoginRoute
  MembersRoute: typeof MembersRoute
  NotificationsRoute: typeof NotificationsRoute
  ParentRoute: typeof ParentRoute
  ProfileRoute: typeof ProfileRoute
  ReadLaterRoute: typeof ReadLaterRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SchedulingRoute: typeof SchedulingRoute
  SearchRoute: typeof SearchRoute
  SettingsRoute: typeof SettingsRoute
  SurveysRoute: typeof SurveysRoute
  TasksRoute: typeof TasksRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  ArticlesSlugRoute: typeof ArticlesSlugRouteWithChildren
  ArticlesNewRoute: typeof ArticlesNewRoute
  CalendarCoordinationRoute: typeof CalendarCoordinationRoute
  CalendarSchedulingRoute: typeof CalendarSchedulingRoute
  CategoriesSlugRoute: typeof CategoriesSlugRoute
  DeskNewsletterRoute: typeof DeskNewsletterRoute
  ForumThreadIdRoute: typeof ForumThreadIdRoute
  ForumNewRoute: typeof ForumNewRoute
  GroupsSlugRoute: typeof GroupsSlugRoute
  InvitesTokenRoute: typeof InvitesTokenRoute
  LibraryFolderIdRoute: typeof LibraryFolderIdRoute
  LibraryDownloadsRoute: typeof LibraryDownloadsRoute
  STokenRoute: typeof STokenRoute
  SurveysSurveyIdRoute: typeof SurveysSurveyIdRouteWithChildren
  SurveysNewRoute: typeof SurveysNewRoute
  TagsSlugRoute: typeof TagsSlugRoute
  UsersUserIdRoute: typeof UsersUserIdRouteWithChildren
  ArticlesIndexRoute: typeof ArticlesIndexRoute
  GroupsIndexRoute: typeof GroupsIndexRoute
  CalendarEventsEventIdRoute: typeof CalendarEventsEventIdRoute
  ForumPostPostIdRoute: typeof ForumPostPostIdRoute
  InvitesDirectInviteIdRoute: typeof InvitesDirectInviteIdRoute
  LibraryFilesFileIdShareRoute: typeof LibraryFilesFileIdShareRoute
  LibraryFoldersFolderIdShareRoute: typeof LibraryFoldersFolderIdShareRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks': {
      id: '/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof TasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/surveys': {
      id: '/surveys'
      path: '/surveys'
      fullPath: '/surveys'
      preLoaderRoute: typeof SurveysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduling': {
      id: '/scheduling'
      path: '/scheduling'
      fullPath: '/scheduling'
      preLoaderRoute: typeof SchedulingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/read-later': {
      id: '/read-later'
      path: '/read-later'
      fullPath: '/read-later'
      preLoaderRoute: typeof ReadLaterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parent': {
      id: '/parent'
      path: '/parent'
      fullPath: '/parent'
      preLoaderRoute: typeof ParentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/members': {
      id: '/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof MembersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library': {
      id: '/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guide': {
      id: '/guide'
      path: '/guide'
      fullPath: '/guide'
      preLoaderRoute: typeof GuideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forum': {
      id: '/forum'
      path: '/forum'
      fullPath: '/forum'
      preLoaderRoute: typeof ForumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookmarks': {
      id: '/bookmarks'
      path: '/bookmarks'
      fullPath: '/bookmarks'
      preLoaderRoute: typeof BookmarksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guide/': {
      id: '/guide/'
      path: '/'
      fullPath: '/guide/'
      preLoaderRoute: typeof GuideIndexRouteImport
      parentRoute: typeof GuideRoute
    }
    '/groups/': {
      id: '/groups/'
      path: '/groups'
      fullPath: '/groups/'
      preLoaderRoute: typeof GroupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/': {
      id: '/articles/'
      path: '/articles'
      fullPath: '/articles/'
      preLoaderRoute: typeof ArticlesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$userId': {
      id: '/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof UsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tags/$slug': {
      id: '/tags/$slug'
      path: '/tags/$slug'
      fullPath: '/tags/$slug'
      preLoaderRoute: typeof TagsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/surveys_/new': {
      id: '/surveys_/new'
      path: '/surveys/new'
      fullPath: '/surveys/new'
      preLoaderRoute: typeof SurveysNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/surveys_/$surveyId': {
      id: '/surveys_/$surveyId'
      path: '/surveys/$surveyId'
      fullPath: '/surveys/$surveyId'
      preLoaderRoute: typeof SurveysSurveyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library_/downloads': {
      id: '/library_/downloads'
      path: '/library/downloads'
      fullPath: '/library/downloads'
      preLoaderRoute: typeof LibraryDownloadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library_/$folderId': {
      id: '/library_/$folderId'
      path: '/library/$folderId'
      fullPath: '/library/$folderId'
      preLoaderRoute: typeof LibraryFolderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invites/$token': {
      id: '/invites/$token'
      path: '/invites/$token'
      fullPath: '/invites/$token'
      preLoaderRoute: typeof InvitesTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guide/$topic': {
      id: '/guide/$topic'
      path: '/$topic'
      fullPath: '/guide/$topic'
      preLoaderRoute: typeof GuideTopicRouteImport
      parentRoute: typeof GuideRoute
    }
    '/groups/$slug': {
      id: '/groups/$slug'
      path: '/groups/$slug'
      fullPath: '/groups/$slug'
      preLoaderRoute: typeof GroupsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forum_/new': {
      id: '/forum_/new'
      path: '/forum/new'
      fullPath: '/forum/new'
      preLoaderRoute: typeof ForumNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forum_/$threadId': {
      id: '/forum_/$threadId'
      path: '/forum/$threadId'
      fullPath: '/forum/$threadId'
      preLoaderRoute: typeof ForumThreadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desk/newsletter': {
      id: '/desk/newsletter'
      path: '/desk/newsletter'
      fullPath: '/desk/newsletter'
      preLoaderRoute: typeof DeskNewsletterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories/$slug': {
      id: '/categories/$slug'
      path: '/categories/$slug'
      fullPath: '/categories/$slug'
      preLoaderRoute: typeof CategoriesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar_/scheduling': {
      id: '/calendar_/scheduling'
      path: '/calendar/scheduling'
      fullPath: '/calendar/scheduling'
      preLoaderRoute: typeof CalendarSchedulingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar_/coordination': {
      id: '/calendar_/coordination'
      path: '/calendar/coordination'
      fullPath: '/calendar/coordination'
      preLoaderRoute: typeof CalendarCoordinationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/new': {
      id: '/articles/new'
      path: '/articles/new'
      fullPath: '/articles/new'
      preLoaderRoute: typeof ArticlesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/$slug': {
      id: '/articles/$slug'
      path: '/articles/$slug'
      fullPath: '/articles/$slug'
      preLoaderRoute: typeof ArticlesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/surveys_/$surveyId/': {
      id: '/surveys_/$surveyId/'
      path: '/'
      fullPath: '/surveys/$surveyId/'
      preLoaderRoute: typeof SurveysSurveyIdIndexRouteImport
      parentRoute: typeof SurveysSurveyIdRoute
    }
    '/articles/$slug/': {
      id: '/articles/$slug/'
      path: '/'
      fullPath: '/articles/$slug/'
      preLoaderRoute: typeof ArticlesSlugIndexRouteImport
      parentRoute: typeof ArticlesSlugRoute
    }
    '/surveys_/$surveyId/respond': {
      id: '/surveys_/$surveyId/respond'
      path: '/respond'
      fullPath: '/surveys/$surveyId/respond'
      preLoaderRoute: typeof SurveysSurveyIdRespondRouteImport
      parentRoute: typeof SurveysSurveyIdRoute
    }
    '/surveys_/$surveyId/edit': {
      id: '/surveys_/$surveyId/edit'
      path: '/edit'
      fullPath: '/surveys/$surveyId/edit'
      preLoaderRoute: typeof SurveysSurveyIdEditRouteImport
      parentRoute: typeof SurveysSurveyIdRoute
    }
    '/invites/direct/$inviteId': {
      id: '/invites/direct/$inviteId'
      path: '/invites/direct/$inviteId'
      fullPath: '/invites/direct/$inviteId'
      preLoaderRoute: typeof InvitesDirectInviteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forum_/post/$postId': {
      id: '/forum_/post/$postId'
      path: '/forum/post/$postId'
      fullPath: '/forum/post/$postId'
      preLoaderRoute: typeof ForumPostPostIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar_/events/$eventId': {
      id: '/calendar_/events/$eventId'
      path: '/calendar/events/$eventId'
      fullPath: '/calendar/events/$eventId'
      preLoaderRoute: typeof CalendarEventsEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/$slug/edit': {
      id: '/articles/$slug/edit'
      path: '/edit'
      fullPath: '/articles/$slug/edit'
      preLoaderRoute: typeof ArticlesSlugEditRouteImport
      parentRoute: typeof ArticlesSlugRoute
    }
    '/users/$userId/collections/$slug': {
      id: '/users/$userId/collections/$slug'
      path: '/collections/$slug'
      fullPath: '/users/$userId/collections/$slug'
      preLoaderRoute: typeof UsersUserIdCollectionsSlugRouteImport
      parentRoute: typeof UsersUserIdRoute
    }
    '/library_/folders/$folderId/share': {
      id: '/library_/folders/$folderId/share'
      path: '/library/folders/$folderId/share'
      fullPath: '/library/folders/$folderId/share'
      preLoaderRoute: typeof LibraryFoldersFolderIdShareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library_/files/$fileId/share': {
      id: '/library_/files/$fileId/share'
      path: '/library/files/$fileId/share'
      fullPath: '/library/files/$fileId/share'
      preLoaderRoute: typeof LibraryFilesFileIdShareRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface GuideRouteChildren {
  GuideTopicRoute: typeof GuideTopicRoute
  GuideIndexRoute: typeof GuideIndexRoute
}

const GuideRouteChildren: GuideRouteChildren = {
  GuideTopicRoute: GuideTopicRoute,
  GuideIndexRoute: GuideIndexRoute,
}

const GuideRouteWithChildren = GuideRoute._addFileChildren(GuideRouteChildren)

interface ArticlesSlugRouteChildren {
  ArticlesSlugEditRoute: typeof ArticlesSlugEditRoute
  ArticlesSlugIndexRoute: typeof ArticlesSlugIndexRoute
}

const ArticlesSlugRouteChildren: ArticlesSlugRouteChildren = {
  ArticlesSlugEditRoute: ArticlesSlugEditRoute,
  ArticlesSlugIndexRoute: ArticlesSlugIndexRoute,
}

const ArticlesSlugRouteWithChildren = ArticlesSlugRoute._addFileChildren(
  ArticlesSlugRouteChildren,
)

interface SurveysSurveyIdRouteChildren {
  SurveysSurveyIdEditRoute: typeof SurveysSurveyIdEditRoute
  SurveysSurveyIdRespondRoute: typeof SurveysSurveyIdRespondRoute
  SurveysSurveyIdIndexRoute: typeof SurveysSurveyIdIndexRoute
}

const SurveysSurveyIdRouteChildren: SurveysSurveyIdRouteChildren = {
  SurveysSurveyIdEditRoute: SurveysSurveyIdEditRoute,
  SurveysSurveyIdRespondRoute: SurveysSurveyIdRespondRoute,
  SurveysSurveyIdIndexRoute: SurveysSurveyIdIndexRoute,
}

const SurveysSurveyIdRouteWithChildren = SurveysSurveyIdRoute._addFileChildren(
  SurveysSurveyIdRouteChildren,
)

interface UsersUserIdRouteChildren {
  UsersUserIdCollectionsSlugRoute: typeof UsersUserIdCollectionsSlugRoute
}

const UsersUserIdRouteChildren: UsersUserIdRouteChildren = {
  UsersUserIdCollectionsSlugRoute: UsersUserIdCollectionsSlugRoute,
}

const UsersUserIdRouteWithChildren = UsersUserIdRoute._addFileChildren(
  UsersUserIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  BookmarksRoute: BookmarksRoute,
  CalendarRoute: CalendarRoute,
  DashboardRoute: DashboardRoute,
  ForumRoute: ForumRoute,
  GuideRoute: GuideRouteWithChildren,
  LibraryRoute: LibraryRoute,
  LoginRoute: LoginRoute,
  MembersRoute: MembersRoute,
  NotificationsRoute: NotificationsRoute,
  ParentRoute: ParentRoute,
  ProfileRoute: ProfileRoute,
  ReadLaterRoute: ReadLaterRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SchedulingRoute: SchedulingRoute,
  SearchRoute: SearchRoute,
  SettingsRoute: SettingsRoute,
  SurveysRoute: SurveysRoute,
  TasksRoute: TasksRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  ArticlesSlugRoute: ArticlesSlugRouteWithChildren,
  ArticlesNewRoute: ArticlesNewRoute,
  CalendarCoordinationRoute: CalendarCoordinationRoute,
  CalendarSchedulingRoute: CalendarSchedulingRoute,
  CategoriesSlugRoute: CategoriesSlugRoute,
  DeskNewsletterRoute: DeskNewsletterRoute,
  ForumThreadIdRoute: ForumThreadIdRoute,
  ForumNewRoute: ForumNewRoute,
  GroupsSlugRoute: GroupsSlugRoute,
  InvitesTokenRoute: InvitesTokenRoute,
  LibraryFolderIdRoute: LibraryFolderIdRoute,
  LibraryDownloadsRoute: LibraryDownloadsRoute,
  STokenRoute: STokenRoute,
  SurveysSurveyIdRoute: SurveysSurveyIdRouteWithChildren,
  SurveysNewRoute: SurveysNewRoute,
  TagsSlugRoute: TagsSlugRoute,
  UsersUserIdRoute: UsersUserIdRouteWithChildren,
  ArticlesIndexRoute: ArticlesIndexRoute,
  GroupsIndexRoute: GroupsIndexRoute,
  CalendarEventsEventIdRoute: CalendarEventsEventIdRoute,
  ForumPostPostIdRoute: ForumPostPostIdRoute,
  InvitesDirectInviteIdRoute: InvitesDirectInviteIdRoute,
  LibraryFilesFileIdShareRoute: LibraryFilesFileIdShareRoute,
  LibraryFoldersFolderIdShareRoute: LibraryFoldersFolderIdShareRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
